module.exports = __webpack_public_path__ + "img/spare.9769caac.jpg";